import React from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div className="min-h-screen" data-testid="about-page">
      {/* Hero */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1620109176813-e91290f6c795?w=1920&q=80"
            alt="Leather craftsmanship"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-leather-900/60"></div>
        </div>
        <div className="relative z-10 text-center px-6">
          <h1 className="font-heading text-4xl md:text-5xl text-white mb-4">Our Story</h1>
          <p className="text-cream-100/80 max-w-lg mx-auto">
            Crafting premium leather goods since the beginning
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="px-6 md:px-12 lg:px-24 py-24">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs tracking-[0.3em] uppercase text-leather-400 mb-4 text-center">The Beginning</p>
          <h2 className="font-heading text-3xl md:text-4xl text-leather-900 mb-8 text-center">
            Born from Passion
          </h2>
          <div className="space-y-6 text-leather-600 leading-relaxed">
            <p>
              Belt & Tingz was founded with a simple belief: that exceptional leather goods can transform the everyday into something extraordinary. What started as a small workshop has grown into a brand synonymous with quality, craftsmanship, and timeless style.
            </p>
            <p>
              Our journey began with a single belt—hand-cut, hand-stitched, and crafted from the finest full-grain leather. Today, we continue this tradition of excellence across our entire collection, from wallets to dog collars, fragrances to footwear.
            </p>
            <p>
              Every piece that bears our name is made to last a lifetime, developing character and beauty with each passing year. We believe in sustainability through durability—creating products that don't just survive but thrive through years of use.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="px-6 md:px-12 lg:px-24 py-24 bg-cream-100">
        <div className="text-center mb-16">
          <p className="text-xs tracking-[0.3em] uppercase text-leather-400 mb-4">What We Stand For</p>
          <h2 className="font-heading text-3xl md:text-4xl text-leather-900">Our Values</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          <div className="text-center">
            <div className="w-16 h-16 border border-leather-900 flex items-center justify-center mx-auto mb-6">
              <span className="font-accent text-xl text-leather-900">Q</span>
            </div>
            <h3 className="font-heading text-xl text-leather-900 mb-3">Quality</h3>
            <p className="text-leather-600 text-sm">
              We source only the finest materials and employ time-honored techniques to create products that exceed expectations.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 border border-leather-900 flex items-center justify-center mx-auto mb-6">
              <span className="font-accent text-xl text-leather-900">C</span>
            </div>
            <h3 className="font-heading text-xl text-leather-900 mb-3">Craftsmanship</h3>
            <p className="text-leather-600 text-sm">
              Every stitch, cut, and finish is executed with precision by skilled artisans who take pride in their work.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 border border-leather-900 flex items-center justify-center mx-auto mb-6">
              <span className="font-accent text-xl text-leather-900">S</span>
            </div>
            <h3 className="font-heading text-xl text-leather-900 mb-3">Sustainability</h3>
            <p className="text-leather-600 text-sm">
              We believe in creating products that last, reducing waste and environmental impact through durability.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-6 md:px-12 lg:px-24 py-24 bg-leather-900 text-center">
        <h2 className="font-heading text-3xl md:text-4xl text-white mb-6">
          Experience the Difference
        </h2>
        <p className="text-cream-100/70 max-w-lg mx-auto mb-8">
          Discover our collection of premium leather goods and find your perfect piece.
        </p>
        <Link to="/shop/belts" className="inline-block px-8 py-4 bg-gold-500 text-leather-900 text-sm tracking-widest uppercase hover:bg-gold-600 transition-colors">
          Shop Now
        </Link>
      </section>
    </div>
  );
}
